/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgDatabaseSignalBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Group 1">
      <path
        id="Icon"
        d="M0.833252 9.74484V17.2106C0.833252 18.8599 3.46549 20.1969 6.71252 20.1969C9.95954 20.1969 12.5918 18.8599 12.5918 17.2106V9.74484M0.833252 9.74484C0.833252 11.3941 3.46549 12.7311 6.71252 12.7311C9.95955 12.7311 12.5918 11.3941 12.5918 9.74484M0.833252 9.74484C0.833252 8.09555 3.46549 6.75854 6.71252 6.75854C9.95955 6.75854 12.5918 8.09555 12.5918 9.74484M12.5918 13.4777C12.5918 15.127 9.95954 16.464 6.71252 16.464C3.46549 16.464 0.833252 15.127 0.833252 13.4777"
        stroke="currentColor"
        strokeWidth={1.5}
      />
      <path
        id="Vector"
        d="M9.5832 4.74999C12.5229 5.16991 14.9999 6.83333 14.9999 10.5833M9.65598 2.53152C13.8516 2.97907 17.4998 5.16668 17.4999 10.5833"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
const SvgDatabaseSignal = wrapIcon(SvgDatabaseSignalBase);
export default SvgDatabaseSignal;
